import React from "react"

const VerifyBusinessCard = ({ proId, bookableUrl }) => {
    const claimUrl = `${bookableUrl}/pro/register/claim/${proId}`

    return (
        <div className="verify-business-card">
            <h3>Verify this business for free</h3>
            <p>Get verified to receive customer requests, update your details, and more.</p>
            <a href={claimUrl} className="verify-business-btn">Verify this business</a>
        </div>
    )
}

export default VerifyBusinessCard
